import { page, bootstrapSelect } from '../init'

$(function() {
  if (page.controller() === 'templates') {
    console.debug('[JS] bootstrap-select')
    bootstrapSelect.trigger({showSubtext: true})
  }
})
